<template>
	<div class="stars-outer">
		<div :style="'width:' + value + '%'" class="stars-inner"></div>
	</div>
</template>

<script>
  export default {
      components: {        
      },
      props: ['value'],
      data() {
        return {          
        };
      },
      methods: {
      }
    };
</script>

<style scoped>
	.stars-outer {
	  font-size: 12px;
	  display: inline-block;
	  position: relative;
	  font-family: 'Font Awesome 5 Free';
	  color: #A09660;
	}
	 
	.stars-outer::before {
	  content: "\f005 \f005 \f005 \f005 \f005";
	}
	 
	.stars-inner {
	  position: absolute;
	  top: 0;
	  left: 0;
	  white-space: nowrap;
	  overflow: hidden;
	  width: 0;
	}
	 
	.stars-inner::before {
	  content: "\f005 \f005 \f005 \f005 \f005";
	  color: #f8ce0b;
	  font-weight:900;
	}
</style>